import React, { createContext, useContext, useState, useEffect } from "react";
import { getLastRefreshTimeDetails } from "../Samarth Module/api/lastRefreshTime";
import { tab } from "@testing-library/user-event/dist/tab";

const RefreshContext = createContext();

export const RefreshProvider = ({ children }) => {
    const [lastRefreshData, setLastRefreshData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPageLabel, setCurrentPageLabel] = useState("");
    const [currentSubPageLabel, setCurrentSubPageLabel] = useState("");

    useEffect(() => {
        const fetchLastRefreshTime = async () => {
            try {
                setIsLoading(true);
                const response = await getLastRefreshTimeDetails();
                if (response.status === "success") {
                    setLastRefreshData(response.data);
                }
            } catch (error) {
                console.error("Error fetching last refresh time:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchLastRefreshTime();
    }, []);

    const formatRefreshTime = (dateStr) => {
        if (!dateStr) return "-";
        try {
            let date = new Date(dateStr);

            if (isNaN(date.getTime())) return dateStr;

            const now = new Date();
            const utcNow = new Date(now.toUTCString());
            const istNow = new Date(utcNow.getTime() + 5.5 * 60 * 60 * 1000);

            const diffHours = (istNow.getHours() - date.getHours());

            let adjustedDate = date;

            if (diffHours >= 5 || diffHours <= -5) {
                adjustedDate = new Date(date.getTime() + 5.5 * 60 * 60 * 1000);
            }

            // Format to IST
            const options = {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
            };

            return adjustedDate
                .toLocaleString("en-IN", options)
                .replace(",", "");
        } catch (err) {
            console.error("Date formatting failed:", err);
            return dateStr;
        }
    };

    // Helper function to get refresh data by page/tab label
    const getRefreshDataByPage = (tabLabel, subLabel = "") => {
        if (!tabLabel || lastRefreshData.length === 0) return [];
        const searchLabel = subLabel || tabLabel;

        if (searchLabel === "DPR(Plan VS Actual)") {
            return lastRefreshData.filter(
                (item) =>
                    item.Page &&
                    (item.Page.toLowerCase().includes("dpr") ||
                        item.Page.toLowerCase().includes("dfos") ||
                        item.Page.toLowerCase().includes("sap"))
            );
        }

        if (tabLabel === "RMPM Alert" && subLabel) {
            return lastRefreshData.filter((item) => {
                if (!item?.Page) return false;
                const page = item.Page.toLowerCase().trim();
                const subLabelPart = subLabel.toLowerCase().trim();
                return page.includes(subLabelPart);
            });
        }

        const pageData = lastRefreshData.filter((item) => {
            if (!item?.Page || !searchLabel) return false;
            const page = item.Page.toLowerCase().trim();
            const labelPart = searchLabel.toLowerCase().split(" ")[0].trim();
            return page.includes(labelPart);
        });
        return pageData;
    };

    return (
        <RefreshContext.Provider
            value={{
                lastRefreshData,
                setLastRefreshData,
                isLoading,
                currentPageLabel,
                setCurrentPageLabel,
                currentSubPageLabel,
                setCurrentSubPageLabel,
                getRefreshDataByPage,
                formatRefreshTime,
            }}
        >
            {children}
        </RefreshContext.Provider>
    );
};

export const useRefresh = () => {
    const context = useContext(RefreshContext);
    return context;
};
